import React from "react";
import { Link } from "react-router-dom";
import {
  TableRow,
  TableCell,
  Box,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Edit } from "@mui/icons-material";

const QuickTapsTableRow = ({ session, categoryLabel }) => {
  return (
    <TableRow
      sx={{
        '&:hover': { backgroundColor: '#f5f5f5' },
        '& .MuiTableCell-root': {
          padding: '4px 8px',
          fontSize: '0.8rem'
        }
      }}
    >
      <TableCell sx={{ minWidth: 160, width: '22%' }}>
        <Typography variant="body2" sx={{ wordBreak: 'break-word', fontSize: '0.8rem', lineHeight: 1.2 }}>
          {session.title}
        </Typography>
      </TableCell>
      <TableCell sx={{ minWidth: 120, width: '18%' }}>
        <Typography variant="body2" sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
          {categoryLabel}
        </Typography>
      </TableCell>
      <TableCell sx={{ minWidth: 60, width: '8%', fontSize: '0.75rem' }}>{session.duration}</TableCell>
      <TableCell align="center" sx={{ minWidth: 80, width: '10%' }}>
        <Typography
          variant="body2"
          sx={{
            color: session.is_active  ? 'success.main' : 'error.main',
            fontWeight: 'bold',
            fontSize: '0.75rem'
          }}
        >
          {session.is_active  ? 'Active' : 'Inactive'}
        </Typography>
      </TableCell>
      <TableCell align="center" sx={{ minWidth: 80, width: '10%', fontSize: '0.75rem' }}>
        {session.is_featured  ? 'Featured' : 'Normal'}
      </TableCell>
      <TableCell align="center" sx={{ minWidth: 80, width: '10%', fontSize: '0.75rem' }}>
        {session.is_premium  ? 'Premium' : 'Free'}
      </TableCell>
      <TableCell align="center" sx={{ minWidth: 60, width: '10%' }}>
        {session.author?.author_image && (
          <Tooltip title={session.author.author_name}>
            <Box
              component="img"
              src={session.author.author_image}
              alt={session.author.author_name}
              sx={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                objectFit: 'cover',
                border: '1px solid',
                borderColor: 'divider'
              }}
            />
          </Tooltip>
        )}
      </TableCell>
      <TableCell align="right" sx={{ minWidth: 60, width: '12%' }}>
        <Tooltip title="Edit">
          <IconButton
            component={Link}
            to={`/quick-taps/edit/${session.id}`}
            color="info"
            size="small"
            sx={{
              '&:hover': { backgroundColor: 'action.hover' },
              padding: '4px'
            }}
          >
            <Edit sx={{ fontSize: 16 }} />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default QuickTapsTableRow;
